import { useState } from "react";
import Container from "../common/Container";

const WhyChooseCard = (properties) => (
  <div
    key={properties.key}
    className="py-7 px-4 md:p-8 mb-8 md:my-0 rounded-2xl border border-solid border-gray-100/10"
    id={properties.id}
    onMouseEnter={properties.onmouseenter}
    onMouseLeave={properties.onmouseleave}
  >
    <h3
      style={properties.titlestyle}
      className="text-xl md:text-2xl font-semibold text-white mb-2 md:mb-6"
    >
      <span>{properties.heading}</span>
    </h3>
    <div
      dangerouslySetInnerHTML={{ __html: properties.description }}
      className="text-white text-justify text-base [&>p]:pb-4"
    ></div>
  </div>
);

const WhyChoose = ({ titlestyle, featureSection }) => {
  const [currentCard, setCurrentCard] = useState();
  const { headLine } = featureSection;
  const { cards } = featureSection;

  return (
    <Container large className="bg-primary-black py-24 md:py-20 lg:py-40">
      <h2 className="text-4xl md:text-3xl leading-normal lg:text-6xl md:leading-snug lg:leading-tight font-medium text-white mb-14 lg:mb-8">
        <span>{headLine}</span>
      </h2>
      <div className="grid grid-cols-none md:grid-cols-2 xl:grid-cols-3 md:gap-4">
        {cards.map((values, index) => (
          <div key={values.title} className="flex">
            <WhyChooseCard
              description={values.description}
              heading={values.title}
              onmouseenter={() => {
                setCurrentCard(index);
              }}
              onmouseleave={() => setCurrentCard()}
              titlestyle={index === currentCard ? titlestyle : undefined}
            />
          </div>
        ))}
      </div>
    </Container>
  );
};

export default WhyChoose;
